<template>
    <div>
        <div class="header pb-2 d-flex align-items-center bg-safety">
            <div class="container align-items-center mt-9 mb-4">
                <div class="row mb-5">
                    <div class="col-6">
                        <h1 class="display-1 text-white mt-0 mb-5 text-white" style="font-weight: 400; text-shadow: 1px 1px #000;">
                            Безопасность
                        </h1>
                        <h1 class="text-white" style="font-weight: 400; text-shadow: 1px 1px #000;">
                            Современное сквозное шифрование обеспечивает безопасность всей вашей переписки и обмен документами.
                        </h1>
                    </div>
                    <div class="col-6">
                    </div>
                </div>
            </div>
            <div class="separator separator-bottom separator-skew zindex-100">
                <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
                </svg>
            </div>
        </div>

        <div class="container mt-6 mb-6">
            <div class="row mb-4">
                <div class="col-8">
                    <h2>
                        Использование надежного сквозного шифрования гарантирует, что только вы и человек, с которым вы
                        общаетесь, можете прочитать содержимое, а никто другой, даже Командор.
                    </h2>
                </div>
                <div class="col-4"></div>
            </div>
            <div class="row mb-4">
                <div class="col-8">
                    <h2>Ваши сообщения и документы защищены секретным замком чата . Только у получателя и у вас есть
                        специальный ключ, который необходим, чтобы разблокировать и прочитать ваши сообщения.
                    </h2>
                </div>
                <div class="col-4"></div>
            </div>
            <div class="row mb-4">
                <div class="col-8">
                    <h2>С помощью вашей личной электронной подписи, которая находится только у вас на вашем устройстве,
                        происходит дополнительное шифрование и дешифрование секретного ключа чата.
                    </h2>
                </div>
                <div class="col-4"></div>
            </div>
            <div class="row mb-4">
                <div class="col-8">
                    <h2>Шифрование и дешифрование происходит на конечных устройствах пользователей. Кроме того, данные
                        остаются зашифрованными, пока не будут доставлены к месту назначения.
                    </h2>
                </div>
                <div class="col-4"></div>
            </div>
            <div class="row mb-4">
                <div class="col-8">
                    <h2>При подписании документов в Командоре именно ЭП является гарантом целостности и подлинности
                        подписанного документа.<br/>
                        Каждое несанкционированное изменение будет автоматически выявлено при первой же проверке
                        подписанного документа.
                    </h2>
                </div>
                <div class="col-4"></div>
            </div>
        </div>

    </div>
</template>
<script>
  export default {
    data () {
      return {
        // color: 'rgb(255,255,255, 1)'
        color: '#ced4da'
      }
    },
  };
</script>
<style>
    .bg-safety {
        background-image: url(/img/bg-safety.jpg);
        background-size: cover;
        background-position: center top;
        min-height: 525px;
    }
</style>
